module.exports = __webpack_public_path__ + "static/media/Cooperativa El Rey del Hielo.e9aaebc5.jpg";